
import React from "react";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabContentWithImage } from "./TabContent";

interface IndustriesMenuProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  allImagesLoaded: boolean;
}

export const IndustriesMenu: React.FC<IndustriesMenuProps> = ({
  activeTab,
  onTabChange,
  allImagesLoaded
}) => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-gray-200 text-primary text-sm font-medium">Industries</NavigationMenuTrigger>
      <NavigationMenuContent className="w-[95vw] min-w-[95vw] max-w-[1000px] h-[500px] bg-white rounded-md shadow-lg p-4 border border-gray-200">
        <Tabs value={activeTab} onValueChange={onTabChange} orientation="vertical" className="flex">
          <TabsList className="flex flex-col w-1/4 h-[450px] bg-gray-50 rounded-l-md space-y-1 p-2 border-r border-primary portrait:w-1/4 portrait:min-w-[120px]">
            <TabsTrigger value="telecom" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Telecom
            </TabsTrigger>
            <TabsTrigger value="fsi" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              FSI
            </TabsTrigger>
            <TabsTrigger value="manufacturing" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Manufacturing
            </TabsTrigger>
          </TabsList>
          <TabsContent value="telecom" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1604004555489-723a93d6ce74?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Telecom"
              title="Telecommunications"
              description="AI solutions for telecom providers to optimize network operations, improve customer retention, and enable next-generation services."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="fsi" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="FSI"
              title="Financial Services"
              description="Transformative AI solutions for banks, insurance, and investment firms to enhance risk management and customer experiences."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="manufacturing" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Manufacturing"
              title="Manufacturing"
              description="AI-powered solutions for optimizing production lines, predictive maintenance, and supply chain enhancement in manufacturing."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
        </Tabs>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
